import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x22800000 {
  commandID: number;
  fileName: string;
  posit: number;
  data_size: number;
  data_data: string;
}

export function Command0x22800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    commandID: 0,
    fileName: "",
    posit: 0,
    data_size: 0,
    data_data: "",
  };

  const [fields, setFields] = React.useState<Form0x22800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x22800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const p = { ...fields, [prop]: event.target.value };

      handleChange(
        JSON.stringify({
          commandID: p.commandID,
          fileName: p.fileName,
          posit: p.posit,
          data: {
            size: p.data_size,
            data: p.data_data,
          },
        })
      );
    };

  useEffect(() => {
    const params = JSON.parse(value);

    console.log("--->", params);

    if (!params.commandID) {
      params.commandID = 0;
    }
    if (!params.fileName) {
      params.fileName = "";
    }
    if (!params.posit) {
      params.posit = 0;
    }
    if (!params.data) {
      params.data = {};
    }

    if (!params.data.size) {
      params.data.size = 0;
    }
    if (!params.data.data) {
      params.data.data = "";
    }

    params.data_size = params.data.size;
    params.data_data = params.data.data;

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="commandID"
          label="ID запроса"
          margin="dense"
          fullWidth
          value={fields.commandID}
          onChange={handleChangeField("commandID")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="fileName"
          label="Имя файла “12345678.123” (если имя короче, то 0 на конце)"
          margin="dense"
          fullWidth
          value={fields.fileName}
          onChange={handleChangeField("fileName")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="posit"
          label="Смещение"
          margin="dense"
          fullWidth
          value={fields.posit}
          onChange={handleChangeField("posit")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="data_size"
          label="Сколько байт читать (не более 512)"
          margin="dense"
          fullWidth
          value={fields.data_size}
          onChange={handleChangeField("data_size")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="data_data"
          label="Данные"
          margin="dense"
          fullWidth
          multiline
          minRows={4}
          value={fields.data_data}
          onChange={handleChangeField("data_data")}
        />
      </FormControl>
    </>
  );
}
